import '../styles/CommunityGallery.css';

const COLUMNS = [
  {
    id: 'col-1',
    type: 'tall',
    images: ['community-brick-banner.png'],
  },
  {
    id: 'col-2',
    type: 'stacked',
    images: ['community-group-photo.jpg', 'community-hackathon-photo.jpg', 'community-stat-300k.jpg'],
  },
  {
    id: 'col-3',
    type: 'stacked-2',
    images: ['community-events-card.jpg', 'community-event.jpg'],
  },
  {
    id: 'col-4',
    type: 'tall',
    images: ['community-speaker.jpg'],
  },
  {
    id: 'col-5',
    type: 'stacked',
    images: ['community-purple-venue.jpg', 'community-stat-40k.jpg', 'community-lanyard-crowd.jpg'],
  },
];

function Column({ column }) {
  return (
    <div className={`gallery-col gallery-col--${column.type}`}>
      {column.images.map((img) => (
        <img
          key={img}
          src={`${process.env.PUBLIC_URL}/images/${img}`}
          alt=""
          className="gallery-col__img"
        />
      ))}
    </div>
  );
}

function CommunityGallery() {
  return (
    <section className="community">
      <h2 className="community__title">Community</h2>

      <div className="community__viewport">
        <div className="community__track">
          {COLUMNS.map((col) => (
            <Column key={col.id} column={col} />
          ))}
          {COLUMNS.map((col) => (
            <Column key={`${col.id}-dup`} column={col} />
          ))}
        </div>
      </div>
    </section>
  );
}

export default CommunityGallery;